import {observable, action} from "mobx"

export enum NotificationMode {
	Success,
	Error,
  Information,
  None
}

class NotificationStoreImpl {

  @observable mode: NotificationMode;
  text: string = " ";	
  duration: number;

  constructor() {
    this.text = " ";
    this.mode = NotificationMode.None;
    this.duration = -1;
  }


	@action showSuccessMessage(text: string, duration?: number) {
		this.text = text;
		this.mode = NotificationMode.Success;
		this.duration = duration ? duration : 2000;
	}

	@action showInformationMessage(text: string, duration?: number) {
		this.text = text;
		this.mode = NotificationMode.Information;
		this.duration = duration ? duration : 2000;
	}

  @action clearMessage() {
    this.mode = NotificationMode.None;		
	}
}

export var NotificationStore: NotificationStoreImpl = new NotificationStoreImpl();

